import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components';
import { useGlobalEvent } from 'beautiful-react-hooks';
import React, { useState } from 'react';
import Modal from '~/App/Components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import SignUpForFullBonjoroExperience, {
  TitlePosition,
} from '~/App/Modules/Billing/Components/SignUpForFullBonjoroExperience';

export const SHOW_SIGNUP_TO_UPGRADE_MODAL_EVENT_KEY =
  'signup-to-upgrade-modal-open';

const SignupToUpgradeModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onRequestOpen = useGlobalEvent(
    SHOW_SIGNUP_TO_UPGRADE_MODAL_EVENT_KEY as keyof WindowEventMap
  );
  onRequestOpen(() => setIsOpen(true));

  const modalProps = {
    styles: {
      overlay: ({ base }) => ({
        ...base,
        width: '100%',
        padding: 30,
      }),
      content: ({ base }) => ({
        ...base,
        width: '100%',
        padding: 'unset',
        margin: 'auto',
      }),
      panel: ({ base }) => ({
        ...base,
        width: '100%',
        height: 'auto',
        position: 'relative',
        border: 'unset',
        overflow: 'hidden',
        borderRadius: 5,
        padding: 30,
      }),
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      hideActions
      {...modalProps}
    >
      <Button
        variant={ButtonVariant.Icon}
        className='absolute top-0 right-5 text-2xl text-neutral-300 mt-2'
        onClick={() => setIsOpen(false)}
      >
        <FontAwesomeIcon icon={faTimes} />
      </Button>

      <SignUpForFullBonjoroExperience
        title='Get the full Bonjoro experience'
        titlePosition={TitlePosition.Top}
        parentWrapperClassName='flex-col items-center'
      />
    </Modal>
  );
};

export default SignupToUpgradeModal;
